var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("title"),(_vm.tabs)?_c('Tabs',{staticClass:"tabNavigator__block",attrs:{"list":_vm.tabs,"mapTabs":_vm.mapTabs,"passClassItem":"pa-4 p2 tabNavigator__block-item"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }